module.exports = __webpack_public_path__ + "static/images/styles/images/tooltip/shadow.9b325e4b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/tooltip/shadow.png
// module id = 3849
// module chunks = 11